<form [formGroup]="starForm">
    <div class="filter_section">
      <div class="filter-head">
        <button data-target="#collapse520" data-toggle="collapse" class="collapsebtn" type="button">Category</button>
      </div>
      <div class="multi-selection boxins">
        <ngb-rating [max]="5" [(rate)]="starRating" (rateChange)="onStarRatingChange($event)"></ngb-rating>
      </div>
    </div>
  </form>  